<template>
  <base-modal
    :customShowDialog="showImportModal"
    dialog-max-width="70vw"
    :title="$t('modal.addToCanvas.title')"
    :hasMainBtn="false"
    @close="handleClose"
    @confirmed="$emit('confirm')"
  >
    <div slot="body" style="font-size: 16px">
      <display-files
        :queries="queries"
        :hasActionColumn="false"
        @confirm="(id) => $emit('confirm', id)"
        @queryToDeleteId="(q) => this.queryToDelete = q"
      ></display-files>
    </div>
  </base-modal>
</template>

<script>
import Sugar from 'sugar'
import BaseModal from '../modals/BaseModal'
import DisplayFiles from '../parts/DisplayFiles'

export default {
  name: 'add-to-canvas-modal',
  components: {
    Sugar,
    BaseModal,
    DisplayFiles
  },
  props: ['queries', 'defaultSearchName'],
  data () {
    return {
      currentSortField: 'name',
      currentSortAscending: true,
      sortedQueries: [...this.queries]
    }
  },
  watch: {
    queries: function (val, oldVal) {
      this.prepareData()
      this.sortQueries()
    }
  },
  created () {
    Sugar.extend()
  },
  mounted () {
    this.prepareData()
  },
  computed: {
    showImportModal: { get () { return this.$store.state.modalState.showImportModal } }
  },
  methods: {
    prepareData () {
      this.sortedQueries = [...this.queries]
      this.sortedQueries.map(x => {
        x.sugarUpdatedAt = Sugar.Date.create(x.updatedAt)
      })
    },
    formatDate (q) {
      if (q && q.updatedAt) {
        return Sugar.Date.format(q.sugarUpdatedAt, '%d %h %y - %X')
      } else {
        return ''
      }
    },
    formatDateRelative (q) {
      if (q && q.updatedAt) {
        return Sugar.Date.relative(q.sugarUpdatedAt)
      } else {
        return ''
      }
    },
    formulateIcon (targetField) {
      if (targetField === this.currentSortField) {
        return this.currentSortAscending ? 'arrow_drop_down' : 'arrow_drop_up'
      } else {
        return ''
      }
    },
    handleDeleteError (error) {
      this.$emit('error', error)
    },
    formulateSearchName: function (q) {
      return q && q.defaultSearchName
        ? q.defaultSearchName
        : this.defaultSearchName
    },
    sortQueries () {
      if (typeof this.queries === 'undefined' || this.queries === null || this.queries.length <= 1) {
        return
      }
      const f = this.currentSortField
      this.sortedQueries.sort((a, b) => {
        if (f === 'name') {
          return this.currentSortAscending
            ? a[f].localeCompare(b[f])
            : b[f].localeCompare(a[f])
        } else if (f === 'search') {
          return this.currentSortAscending
            ? this.formulateSearchName(a).localeCompare(this.formulateSearchName(b))
            : this.formulateSearchName(b).localeCompare(this.formulateSearchName(a))
        } else {
          if (a.sugarUpdatedAt.isBefore(b.sugarUpdatedAt)) {
            return this.currentSortAscending ? -1 : 1
          }
          if (a.sugarUpdatedAt.isAfter(b.sugarUpdatedAt)) {
            return this.currentSortAscending ? 1 : -1
          }
          return 0
        }
      })
    },
    handleSortClick (targetField) {
      if (targetField === this.currentSortField) {
        this.currentSortAscending = !this.currentSortAscending
      } else {
        this.currentSortField = targetField
        this.currentSortAscending = true
      }
      this.sortQueries()
    },
    handleClose () {
      this.$store.commit('setShowImportModal', false)
      this.$store.commit('setShowMainMenu', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/mainMenu/AddToCanvasModal.vue